<app-shared-dialog
  [title]="'custom_fields.custom_fields' | translate"
  [options]="{
    titleIcon: 'chevrons',
    titleIconColor: 'primary',
    confirmText: 'common.save' | translate,
    cancelText: 'common.cancel' | translate,
    confirmButtonStyle: 'primary',
    confirmIcon: 'arrow-right',
    confirmIconPosition: 'end'
  }" (confirm)="save()" (cancel)="cancel()">
  <div class="custom-fields-container">
    <app-object-custom-fields-form
      [objectCustomFields]="data.objectCustomFields"
      (save)="saveCustomerCustomFields($event)"
      [showSaveButton]="false"
    ></app-object-custom-fields-form>
  </div>
</app-shared-dialog>
